import { useEffect, useRef, useState, RefObject } from "react";

export function useInView<T extends HTMLElement>(thresholdDesktop = 0.4, thresholdMobile = 0.07): [RefObject<T>, boolean] {
  const ref = useRef<T>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const isMobile = window.innerWidth <= 960;
    const threshold = isMobile ? thresholdMobile : thresholdDesktop;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          obs.disconnect();
        }
      },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [thresholdDesktop, thresholdMobile]);

  return [ref, inView];
}
